<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-bell"></i>
          로그
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Log</a>
        </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card>
            <b-row>
              <b-col>
                <strong>탐지 로그 상세 ({{ model.id }})</strong>
                <span class="float-right">탐지시각 : {{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>클라이언트 정보</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>공격자: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        <b-link v-if="id" href="javascript:void(0)" @click="copy(model.remote_addr)" v-b-tooltip.hover title="클릭시 복사할 수 있습니다">
                          {{model.remote_addr ? model.remote_addr : '-'}}
                        </b-link>
                        <span v-else>
                          {{model.remote_addr ? model.remote_addr : '-'}}
                        </span>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>
                        XFF:
                        <span class="text-info" v-b-tooltip.hover.right="'XFF: 프록시가 설정 되어 있을 경우 X-Forwarded-For 데이터가 표시됩니다'">
                          <i style='cursor: pointer;' class="fa fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        {{ model.xff ? model.xff : '-' }}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>국가: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_remote_addr" v-b-tooltip.hover>
                        <span v-if="model.country" class="flag-icon" :class="set_flag(model.country)"></span>
                        {{model.country ? model.country : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_protocol" v-b-tooltip.hover>프로토콜: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_protocol" v-b-tooltip.hover>
                        {{model.protocol ? model.protocol : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_port" v-b-tooltip.hover>포트: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover>
                        {{model.client_port ? model.client_port : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_method" v-b-tooltip.hover>메소드: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_method" v-b-tooltip.hover>
                        {{model.method ? model.method : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_request" v-b-tooltip.hover>요청(Byte): </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_request" v-b-tooltip.hover>
                        {{model.request_size ? model.request_size : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_response" v-b-tooltip.hover>응답(Byte): </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_response" v-b-tooltip.hover>
                        {{model.response_size ? model.response_size : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>서버 정보</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>Host(도메인):</label>
                    </b-col>
                    <b-col>
                      <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>포트:</label>
                    </b-col>
                    <b-col>
                      -
                      <!-- <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label> -->
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>대상:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model">{{model.target}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>외부 아이피:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_public ? model.agent.ip_addr_public : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>내부 아이피:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_private ? model.agent.ip_addr_private : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>WAS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.iwaf_type ? model.agent.iwaf_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>운영체제:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.os_type ? model.agent.os_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>호스트(헤더):</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.host ? model.agent.host : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row v-if="model.agent && model.agent.nickname != model.agent.host">
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>이름:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.nickname ? model.agent.nickname : '-'}}</label>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label for="ph_uri" v-b-tooltip.hover>
                        URI <small>:</small>
                        <b-button v-if="model.uri.length > 100" size="sm" @click="view_split_uri = !view_split_uri" variant="info">
                          {{view_split_uri ? 'split' : 'origin'}} view
                        </b-button>
                      </label>
                    </b-col>
                    <b-col>
                      <pre v-if="view_split_uri" for="ph_uri" v-b-tooltip.hover>{{model.uri}}</pre>
                      <pre v-else>{{split_uri(model.uri || '')}}</pre>
                    </b-col>
                  </b-row> -->

                </div>
              </b-col>
              <b-col md="6" style="border-left: 1px solid #dcdcdc;">
                <h4>
                  위험 정보
                  <Bell v-if="model.message && model.message.messages && model.message.messages.length > 1" style="display: inline-block" :size="20" :count="model.message.messages.length" />
                </h4>

                <hr>
                <div>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" for="ph_response">응답(대응):</label>
                    </b-col>
                    <b-col>
                      <b-badge v-if="model.is_block && this.model.block_cnt > 0" variant="danger">차단</b-badge>
                      <b-badge v-else variant="warning">팀지</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="cursor:pointer" md="3">
                      <label for="ph_response" class="font-weight-bold">위험:</label>
                      <span class="text-info" v-b-tooltip.hover title="여러 개의 로그가 존재할 경우 가장 위험도가 높은 것이 표시됩니다 미정의는 '하'로 위험도가 표시됩니다">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(model.severity, 'variant')">
                        {{codes.WAF_SEVERITY_TO_DESC_EASY(model.severity, 'KO')}}
                      </b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold">정책 ID:</label>
                      <span class="text-info" v-b-tooltip.hover title="정해진 정책 번호를 표시합니다 사용자 정책의 경우 사용자 설정에 따라 유동적으로 설정됩니다(8,000,000 ~ 8,999,999)">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-link v-if="id" href="javascript:void(0)" @click="() => quick_search(model.m_id)" v-b-tooltip.hover title="사용자 정책이 아닐 경우 에이전트 페이지에서 정책을 바로 검색할 수 있습니다 클릭해보세요">
                        {{ model.m_id ? model.m_id : '-' }}
                      </b-link>
                      <span v-else>
                        {{ model.m_id ? model.m_id : '-' }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold">정책명:</label>
                    </b-col>
                    <b-col>
                      {{ policy_domain() ? policy_domain() : '-' }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover>
                        <strong>탐지메세지:</strong>
                      </label>
                    </b-col>
                    <b-col>
                      <strong>{{ model.title_i18n ? (temp_i18n[model.title_i18n['KO'].desc] ? temp_i18n[model.title_i18n['KO'].desc] : model.title_i18n['KO'].desc) : (model.title ? model.title : i18nmsg) }}</strong>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label v-b-tooltip.hover>CVE</label>
                    </b-col>
                    <b-col>
                      {{ '-' }}
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>태그:</label>
                    </b-col>
                    <b-col>
                      <span v-for="(x, index) in tags()" v-bind:key="index">
                        {{ x || '-' }} <br>
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="parser_request">
              <b-col md="12">
                <b-form-group>
                  <b>
                    <label for="ph_request" v-b-tooltip.hover>
                      URI<small>:</small>
                    </label>
                    <b-button size="sm" @click="view_split_request = !view_split_request" variant="info">
                      {{view_split_uri ? 'split' : 'origin'}} view
                    </b-button>
                  </b>
                  <pre class="bg-secondary" v-if="view_split_request" for="ph_uri" v-b-tooltip.hover>{{model.request}}</pre>
                  <pre v-else class="bg-secondary">{{split_uri(model.request || '')}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr v-if="has_get_parameter()">
            <b-row v-if="has_get_parameter()">
              <b-col sm="6">
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>요청</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.request}}</pre>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>요청 파라미터</label><br></b>
                  <table>
                    <thead>
                      <th class="border border-dark p-2">변수명</th>
                      <th class="border border-dark p-2">값</th>
                    </thead>
                    <tbody>
                      <tr v-for="(x, index) in parameter()" v-bind:key="index">
                        <td class="p-2">
                          {{x.key}}
                        </td>
                        <td class="p-2">
                          {{x.value}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>요청 헤더</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.headers ? model.headers : '헤더 데이터가 없습니다'}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <center>
              탐지 정보
              <!-- <span class="float-right">
                <span class="text-danger">*</span>
                현재 정책({{model.target}})에서 설정 가능 옵션
              </span> -->
            </center>
            <hr>
            <table v-if="is_error" class="table table-sm table-dark">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">메세지</th>
                  <th scope="col">정책 ID</th>
                  <!-- <th scope="col">Maturity</th>
                  <th scope="col">Accuracy</th> -->
                  <th scope="col">응답</th>
                  <th scope="col">위험</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <th scope="col" colspan="5">
                    데이터가 잘못되었습니다 기술지원팀에 문의해주세요
                  </th>
                </tr>
              </tbody>
            </table>
            <table v-else class="table table-sm table-dark text-center">
              <thead>
                <tr>
                  <th scope="col" rowSpan="2">정책 ID</th>
                  <th scope="col" rowSpan="2">메세지</th>
                  <th scope="col" rowSpan="2" @click="info_threat = true" style="cursor:pointer">
                    대응 및 위험도
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <th v-if="!only_view" scope="col">
                    관리
                    <span class="text-info" v-b-tooltip.hover :title="this.m_Title">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <th v-if="!only_view" scope="col">현재 설정</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                  <th scope="row">
                    <b-link v-if="id" href="javascript:void(0)" @click="() => quick_search(row.details.ruleId)" v-b-tooltip.hover title="사용자 정책이 아닐 경우 정책 설정 페이지에서 정책을 바로 검색할 수 있습니다 클릭해보세요">
                      {{ row.details.ruleId ? row.details.ruleId : '-' }}
                    </b-link>
                    <span v-else>
                      {{ row.details.ruleId ? row.details.ruleId : '-' }}
                    </span>
                  </th>
                  <th scope="row">
                    <span class="text-info" v-if="row.details.i18n && (row.details.i18n['KO'] || row.details.i18n['KR'].desc)" @click="base_policy(row.details)">
                      <i class="fas fa-question-circle"></i>
                    </span>
                    <strong>{{detectInfo ? detectLog[index] : row.message}}</strong>
                    <!-- <strong>{{ row.details.i18n && row.details.i18n['KO'] ? (temp_i18n[row.details.i18n['KO'].desc] ? temp_i18n[row.details.i18n['KO'].desc] : row.details.i18n['KO'].desc) : (ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['KO'] : row.message) }}</strong> -->
                  </th>
                  <th scope="row">
                    <!-- <p>Policy ID : {{row.details.ruleId}} </p> -->
                    <!-- <span>{{row.details.ruleId}} </span>
                    <br> -->
                    <span>
                      <!-- {{row.details.tags}} -->
                      <!-- Response: -->
                      <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                      <b-badge v-else-if="row.details.is_block" variant="danger">차단</b-badge>
                      <b-badge v-else variant="warning">탐지</b-badge>
                    </span>
                    <br>
                    <span>
                      <!-- Risk: -->
                      <span scope="row">
                        <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(row.details.severity, 'variant')">
                          {{codes.WAF_SEVERITY_TO_DESC_EASY(row.details.severity, 'KO')}}
                        </b-badge>
                      </span>
                    </span>
                  </th>
                  <th v-if="!only_view && !loading" scope="row">
                    <b-button :disabled="version < 202207 ? (onOff[index] || check_custom(row.details)) : (row.now_status == codes.WAF_MODE_OFF.VALUE || check_custom(row.details))"  @click=" exception_info = {  applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception,  }; exception_info_modal_add = true; exception_info_modal_remove = false;" size="sm" style="width: fit-content; font-weight: bold;" variant="danger">
                      <span v-if="row.is_domain && !row.is_exception_domain" style="font-size:1.2rem; padding:0px; margin:0px;" class="text-danger">*</span>
                      정책 끄기
                    </b-button>
                    <b-button :disabled="version < 202207 ? (!onOff[index] || check_custom(row.details)) : (row.now_status != codes.WAF_MODE_OFF.VALUE || check_custom(row.details))" @click=" exception_info = {  applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception }; exception_info_modal_remove = true; exception_info_modal_add = false;" size="sm" style="width: fit-content; font-weight: bold;" variant="warning">
                      <span v-if="row.is_domain && row.is_exception_domain" style="font-size:1.2rem;" class="text-danger">*</span>
                      정책 켜기
                    </b-button>
                  </th>
                  <th v-if="!only_view && row.now_status != null"  class="text-weight-bold">
                    {{codes.WAF_MODE_I18N(row.now_status, 'KO')}}
                  </th>
                  <th v-else  class="text-weight-bold">
                    -
                  </th>
                </tr>
              </tbody>
            </table>
            <hr>
            <b-button v-if="!id" size="sm" class="float-right" @click="list">목록으로</b-button>
          </b-card>
        </b-col>
      </b-row>
      <!-- result modal -->
      <b-modal size="m" title="검출에 대한 상세 설명"  class="modal-info" v-model="info_base_policy.is_show" hide-footer @ok="info_base_policy.is_show = false">
        상세 탐지 근거 정보를 제공합니다
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason.match || '-'}}
        </pre>
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason.data || '-'}}
        </pre>
      </b-modal>
      <!-- <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-info" v-model="info_xff" hide-footer @ok="info_xff = false">
        XFF: 프록시가 설정 되어 있을 경우 X-Forwarded-For 데이터가 표시됩니다
      </b-modal> -->
      <!-- 정책 미사용 모달 -->
      <b-modal size="l" title="정책 미사용으로 설정하기"  class="modal-success" v-model="exception_info_modal_add" @ok="add_white">
        <p>{{exception_policy_id}} 정잭을 미사용으로 적용할까요?</p>
        <p>{{policy_domain()}}  정책에 미사용으로 변경되고 탐지 로그에서 보이지 않게 됩니다</p>
        <!-- <hr> -->
        <!-- <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="check_disabled(x)">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group> -->
        <!-- <hr>
        <p>* 적용할 정책 대상을 선택해주세요</p> -->
      </b-modal>
      <b-modal size="m" title="정책 사용 설정하기"  class="modal-success" v-model="exception_info_modal_remove" @ok="remove_white">
        <p>현재 미사용 처리되어 있는 정책을 탐지로 설정합니다</p>
        <!-- 기존 코드-->
        <!-- <p v-if="exception_info.detail.i18n">{{exception_policy_id}} : {{ exception_info.detail.i18n['KO'].desc }} 정책을 탐지로 변경합니다</p> -->

        <!-- 변경 코드-->
        <p v-if="exception_info.detail.i18n">
          {{exception_policy_id}} : {{ exception_info.detail.i18n ? (exception_info.detail.i18n['KO'] ? exception_info.detail.i18n['KO'].desc : exception_info.detail.i18n['KR'].desc) : exception_info.msg }} 정책을 탐지로 변경합니다
        </p>

        <p>탐지로 변경시 탐지 로그 확인이 가능합니다</p>
        <hr>
        <!-- <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="check_disabled(x)">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group> -->
      </b-modal>
      <b-modal size="m" title="Threat"  class="modal-info" v-model="info_threat" hide-footer @ok="info_threat = false">
        응답 유형과 위험도를 표시합니다
        <br>
        응답 유형 : 차단(HTTP 403) 및 탐지(HTTP 200)
        <br>
        위험도 : 정의된 위험도를 표시합니다(위험, 공지, 정보, 사용자정의 등)
      </b-modal>
    </div>
  </div>
</template>

<script>
import App from './app.js';import i18n_toastr from './i18n_data';
 export default Object.assign({}, App);
</script>
